import React, { useContext } from "react";
import Select from "react-select";
import { useColorStyle } from "../hooks/useColorStyle";
import { ThemeContext } from "../context/themeContext";
import ReactDatePicker from "./datepicker";
import AppointmentIcon from "../assets/appointments";
import "../datePicker.css";

export function StatusFilter({
  handleChange,
  page,
  value,
}: {
  handleChange: React.Dispatch<React.SetStateAction<{}>>;
  page: "calls" | "leads";
  value?: string;
}) {
  const { theme } = useContext(ThemeContext);
  const { campaignColorStyles } = useColorStyle(theme);
  const options =
    page === "calls"
      ? [
          { value: "completed", label: "Completed" },
          { value: "scheduled", label: "Scheduled" },
        ]
      : [
          { value: "completed", label: "Completed" },
          { value: "scheduled", label: "Scheduled" },
        ];
  return (
    <Select
      isSearchable={false}
      options={options}
      placeholder="Status"
      styles={campaignColorStyles}
      value={options.find((option) => option.value === value) || null} // Controlled value
      onChange={(e) => handleChange((prev) => ({ ...prev, status: e?.value }))}
    />
  );
}

export function DateFilter({
  handleChange,
  value,
}: {
  handleChange: React.Dispatch<React.SetStateAction<{}>>;
  value?: [Date | null, Date | null];
}) {
  const [starDate, setStartDate] = React.useState<[Date | null, Date | null]>(
    value || [null, null]
  );

  React.useEffect(() => {
    setStartDate(value || [null, null]); // Update local state when value changes
  }, [value]);

  return (
    <ReactDatePicker
      startDate={starDate?.[0]!}
      endDate={starDate?.[1]!}
      onChange={(dates: [Date | null, Date | null] | null) => {
        if (dates) {
          setStartDate(dates);
          if (handleChange) {
            handleChange((prev) => ({ ...prev, dates }));
          }
        }
      }}
      suffix={<AppointmentIcon className={"text-[#758599] size-[16px]"} />}
      placeholderText="Call date range"
      monthsShown={2}
      selectsRange
      inputProps={{
        clearable: true,
        onClear: () => {
          setStartDate([null, null]); // Clear the date state
          if (handleChange) {
            handleChange((prev: any) => {
              const { dates, ...rest } = prev; // Remove the `dates` attribute
              return rest;
            });
          }
        },
      }}
    />
  );
}
